import React from 'react'
import Edit from '../crud/edit'
import menuItems from './menuItems'

const fields = [
  {
    name: 'Homepage Slug',
    prop: 'value',
    type: 'autocomplete',
    references: 'admin/cms_pages',
    referenceProp: 'slug',
    referenceValue: 'slug',
    referenceFilter: (resource) => resource.published_at !== null
  }
]

const EditSettings = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Edit Public Page'
      fields={fields}
      apiPath='admin/settings/homepage_slug'
      successRedirectPath='/settings'
      buildMenuItems={menuItems}
      disableDelete
    />
  )
}

export default EditSettings
